import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { SectionReveal } from './SectionReveal';
interface FaqItem {
  question: string;
  answer: string;
}
interface FaqSectionProps {
  title?: string;
  subtitle?: string;
  items: FaqItem[];
}
export function FaqSection({
  title = 'Questions fréquentes',
  subtitle,
  items
}: FaqSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-cream" data-id="element-13">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <SectionReveal data-id="element-15">
          <div className="text-center mb-12" data-id="element-16">
            <span className="text-xs font-bold tracking-widest text-rosegold uppercase mb-3 block" data-id="element-17">
              FAQ
            </span>
            <h2 className="text-3xl md:text-4xl font-serif text-navy mb-4 font-bold" data-id="element-18">
              {title}
            </h2>
            {subtitle && <p className="text-navy/70 max-w-2xl mx-auto" data-id="element-19">{subtitle}</p>}
          </div>
        </SectionReveal>

        <div className="space-y-4" data-id="element-20">
          {items.map((item, idx) => {
          const isOpen = openIndex === idx;
          return <SectionReveal key={idx} delay={idx * 0.05} data-id="element-21">
                <div className={`bg-white rounded-2xl border transition-all overflow-hidden ${isOpen ? 'border-rosegold/40 shadow-lg shadow-pink-100/50' : 'border-blush hover:border-rosegold/30'}`} data-id="element-22">
                  <button className="w-full text-left p-5 md:p-6 flex items-start justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : idx)} aria-expanded={isOpen} data-id="element-23">
                    <span className="font-serif text-lg md:text-xl text-navy font-semibold leading-tight" data-id="element-24">
                      {item.question}
                    </span>
                    <span className={`flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-rosegold text-white' : 'bg-blush-light text-rosegold'}`} data-id="element-25">
                      {isOpen ? <MinusIcon className="w-4 h-4" data-id="element-26" /> : <PlusIcon className="w-4 h-4" data-id="element-27" />}
                    </span>
                  </button>
                  <AnimatePresence initial={false} data-id="element-28">
                    {isOpen && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} data-id="element-29">
                        <div className="px-5 md:px-6 pb-6 text-navy/75 leading-relaxed" data-id="element-30">
                          {item.answer}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </SectionReveal>;
        })}
        </div>
      </div>
    </section>;
}